import React from 'react';
import styled from 'styled-components';

import Section from '../Section';

import FormWrapper from './subscribeForm/Wrapper';

const Subscribe = () => (
  <SubscribeStyles>
    <WrapperStyles>
      <div id="subscribe">
        <SubscribeHeader>Get the latest news and tips</SubscribeHeader>
        <p>
          Join our email list to get updates on all things Commerce7 delivered
          to your inbox.
        </p>
      </div>
      <FormStyles>
        <FormWrapper />
      </FormStyles>
    </WrapperStyles>
  </SubscribeStyles>
);

const SubscribeStyles = styled(Section)`
  background-color: rgb(245, 246, 250);
`;

const WrapperStyles = styled.div`
  padding: 70px 0;
  ${({ theme }) => `
    @media ${theme.largeUp} {
      display: flex;
      align-items: center;
      justify-content: space-between;
  `}
`;

const SubscribeHeader = styled.h3`
  font-size: var(--heading-size-sm);
  font-weight: var(--font-weight-bold);
`;

const FormStyles = styled.div`
  margin-top: 25px;
  ${({ theme }) => `
    @media ${theme.largeUp} {
      padding-left: 25px;
      margin-top: 0px;
      width: 435px;
  `}
`;

export default Subscribe;
